<script setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { PageHeader, Tabs } from '@drama/ui'

import AllMediaTab from './asset-library/AllMediaTab.vue'
import CuratedTab from './asset-library/CuratedTab.vue'
import TalkingVideosTab from './asset-library/TalkingVideosTab.vue'

const { t } = useI18n()
const route = useRoute()
const tab = ref('talkingVideos')
const packId = typeof route.query.pack_id === 'string' ? route.query.pack_id : ''

const tabs = computed(() => [
  { key: 'talkingVideos', label: t('visualGameAdmin.assetLibrary.tabs.talkingVideos') },
  { key: 'curated', label: t('visualGameAdmin.assetLibrary.tabs.curated') },
  { key: 'allMedia', label: t('visualGameAdmin.assetLibrary.tabs.allMedia') },
])
</script>

<template>
  <div class="asset-library-page vga-page" data-insp-path="apps/visual-game-admin/src/pages/AssetLibrary.vue">
    <PageHeader :title="t('visualGameAdmin.assetLibrary.title')">
      <template #subtitle>
        <span>{{ t('visualGameAdmin.assetLibrary.subtitle') }}</span>
      </template>
    </PageHeader>

    <Tabs v-model="tab" :tabs="tabs">
      <template #talkingVideos>
        <TalkingVideosTab :initial-pack-id="packId" />
      </template>
      <template #curated>
        <CuratedTab />
      </template>
      <template #allMedia>
        <AllMediaTab />
      </template>
    </Tabs>
  </div>
</template>
